// extracted by mini-css-extract-plugin
module.exports = {"listWrapper":"ActivityCategoryList__listWrapper___h5sKC","isLoading":"ActivityCategoryList__isLoading___2qkH5"};